/**
 * Rotas de Navegação do Agendex - Cliente
 * autor: W de Paula
 * data: 31/12/25 | 10h46
 * Modificado: 31/12/25 | 14h08 - Convertido para array de rotas
 */



/**
 * src/routes/clienteRoutes.js
 * Rotas protegidas do cliente
 */

import { lazy, Suspense } from 'react';
import SecureRoute from '../app/Context/privaterouter';
import LoadingSpinner from '../app/ComponentsLogin/LoadingSpinner';

// HOME
const ClienteHome = lazy(() => import('../app/AgendexCliente/pages/Home/home'));
const ClienteExplorarEmpresas = lazy(() => import('../app/AgendexCliente/pages/ExplorarEmpresa/explorarempresas'));
const ClienteDetalheEmpresa = lazy(() => import('../app/AgendexCliente/pages/ExplorarEmpresa/DetalheEmpresa/detalheempresa'));
const ClienteAgendar = lazy(() => import('../app/AgendexCliente/pages/ExplorarEmpresa/DetalheEmpresa/Agendar/agendar'));

// AGENDAMENTOS
const ClienteAgendamentos = lazy(() => import('../app/AgendexCliente/pages/Agendamentos/abertos'));
const ClienteAgendamentosConcluidos = lazy(() => import('../app/AgendexCliente/pages/Agendamentos/concluidos'));
const ClienteAgendamentosExcluidos = lazy(() => import('../app/AgendexCliente/pages/Agendamentos/excluidos'));
const ClienteAgendamentosPendentes = lazy(() => import('../app/AgendexCliente/pages/Agendamentos/pendentes'));

// PERFIL
const ClientePerfil = lazy(() => import('../app/AgendexCliente/pages/Perfil/perfil'));
const ClientePerfilFoto = lazy(() => import('../app/AgendexCliente/pages/Perfil/fotoperfil'));
const ClientePerfilAlterar = lazy(() => import('../app/AgendexCliente/pages/Perfil/alterardadosperfil'));
const ClientePerfilValidaEmail = lazy(() => import('../app/AgendexCliente/pages/Perfil/ativarconta'));

// CONFIGURAÇÕES
const ClienteTrocarCidade = lazy(() => import('../app/AgendexCliente/pages/Configuracoes/trocarcidade'));
const ClienteFaleConosco = lazy(() => import('../app/AgendexCliente/pages/Configuracoes/faleconosco'));
const ClienteNotificacoesInternas = lazy(() => import('../app/AgendexCliente/pages/Configuracoes/notificacoesinternas'));
const ClienteNotificacoes = lazy(() => import('../app/AgendexCliente/pages/Notificacoes/notificacoes'));

// HELPER
const Protected = (Component) => (
  <SecureRoute>
    <Suspense fallback={<LoadingSpinner />}>
      <Component />
    </Suspense>
  </SecureRoute>
);

export const clienteRoutes = [
  // HOME
  { path: "/app/cliente/home", element: Protected(ClienteHome) },
  { path: "/app/cliente/home/explorar", element: Protected(ClienteExplorarEmpresas) },
  { path: "/app/cliente/home/explorar/empresa", element: Protected(ClienteDetalheEmpresa) },
  { path: "/app/cliente/home/explorar/empresa/agendar", element: Protected(ClienteAgendar) },

  // AGENDAMENTOS
  { path: "/app/cliente/agendamentos/abertos", element: Protected(ClienteAgendamentos) },
  { path: "/app/cliente/agendamentos/concluidos", element: Protected(ClienteAgendamentosConcluidos) },
  { path: "/app/cliente/agendamentos/excluidos", element: Protected(ClienteAgendamentosExcluidos) },
  { path: "/app/cliente/agendamentos/pendentes", element: Protected(ClienteAgendamentosPendentes) },

  // PERFIL
  { path: "/app/cliente/perfil", element: Protected(ClientePerfil) },
  { path: "/app/cliente/perfil/foto", element: Protected(ClientePerfilFoto) },
  { path: "/app/cliente/perfil/alterar", element: Protected(ClientePerfilAlterar) },
  { path: "/app/cliente/perfil/cv", element: Protected(ClientePerfilValidaEmail) },

  // CONFIGURAÇÕES
  { path: "/app/cliente/config/trocarcidade", element: Protected(ClienteTrocarCidade) },
  { path: "/app/cliente/config/faleconosco", element: Protected(ClienteFaleConosco) },
  { path: "/app/cliente/config/notificacoes", element: Protected(ClienteNotificacoesInternas) },
  { path: "/app/cliente/notificacoes", element: Protected(ClienteNotificacoes) }
];